//@helpers
const actionTypes = require('constants/actionTypes');

// @ commons
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

//@actions
const signaturePatternActions = require('actions/signaturePattern');

function setVisibleStep(step) {
    return {
        type: actionTypes.ACCOUNT_CANCEL_CHEQUEBOOK_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

function validateStep(step) {
    return {
        type: actionTypes.ACCOUNT_CANCEL_CHEQUEBOOK_VALIDATE_STEP,
        payload: {
            step
        }
    }
}

function setWillCancel(willCancel) {
    return {
        type: actionTypes.ACCOUNT_CANCEL_CHEQUEBOOK_WILL_CANCEL,
        payload: {
            willCancel
        }
    };
}

function reset() {
    return {
        type: actionTypes.ACCOUNT_CANCEL_CHEQUEBOOK_RESET
    };
}

function setMotive(motive) {
    return {
        type: actionTypes.ACCOUNT_CANCEL_CHEQUEBOOK_SET_MOTIVE,
        payload: {
            motive
        }
    };
}

function successCancelChequebook() {
    return {
        type: actionTypes.ACCOUNT_CANCEL_CHEQUEBOOK_SUCCESS
    };
}

function failCancelChequebook(error) {
    return {
        type: actionTypes.ACCOUNT_CANCEL_CHEQUEBOOK_FAILURE,
        payload: error
    };
}

const postChange = (accountId, chequebookIndex) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const nuevaSituacion = getState().accountCancelChequebook.getIn(['steps', 0, 'motive']);
        const chequebookId = getState().accountsCheques.getIn([accountId, 'byOrder', chequebookIndex]);
        const chequebook = getState().accountsCheques.getIn([accountId, 'byId', chequebookId]);
        const accounts = getState().accounts;
        const params = {
            query: {
                dataToken,
                datosConexion: {
                    contrato: {
                        numerodecontrato: accounts.getIn(['byId',accountId,'newContractNumber']),
                        producto: accounts.getIn(['byId',accountId,'newProduct'])
                    }
                },
                monedaCuaderno: chequebook.get('currency'),
                nuevaSituacion,
                numeroChequeDesde: chequebook.get('initialNum')
            }
        };
        APIPost(dispatch, apiURLBuilder.getURL('accountCancelChequesbook'), params)
            .then(response => dispatch(successCancelChequebook(response)))
            .catch(error => {
                if (error instanceof Error) {
                    console.error(error); // eslint-disable-line
                    throw error;
                }
                dispatch(failCancelChequebook({error: error.text}));
            });
    };

    return Promise.resolve().then(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

module.exports = {
    setVisibleStep,
    validateStep,
    setWillCancel,
    postChange,
    reset,
    setMotive
}
